var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Breadcrumb',_vm._l((_vm.currentPath),function(item){return _c('BreadcrumbItem',{key:item.name,attrs:{"to":item}},[_vm._v(_vm._s(_vm.itemTitle(item)))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }